module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('nav', {
    staticClass: "navbar main-header"
  }, [_c('div', {
    staticClass: "wrap-header"
  }, [_c('div', {
    staticClass: "nav-block"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "nav-icon"
  }, [_c('div', {
    staticClass: "nav-nuevo"
  }, [_c('notifications-menu'), _vm._v(" "), _c('user-menu', {
    attrs: {
      "user": _vm.user
    }
  })], 1)])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "logo-nav"
  }, [_c('span', {
    staticClass: "burguer-menu",
    attrs: {
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "logo-sendibox",
    attrs: {
      "src": "/static/img/logo-login.png",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-52514355"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/DashHeader.vue
// module id = 1879
// module chunks = 1